module.exports = __webpack_public_path__ + "media/4x3/gb-nir-43b61fea.svg";